// Per-category theme mapping for product landing pages.
// Each category has its own visual identity to match the product niche.
// Design philosophy: sharp, modern, professional with minimal border radius.

export const CATEGORY_THEMES = {
  industrial: {
    label: "Casă & Reparații",
    accentColor: "#dc2626",
    accentClass: "text-red-600",
    accentBg: "bg-red-600",
    accentBgHover: "hover:bg-red-700",
    accentRing: "ring-red-500",
    accentBorder: "border-red-500",
    accentSoft: "bg-red-50",
    accentSoftText: "text-red-700",
    heroBg: "bg-gradient-to-br from-red-600 via-red-700 to-red-800",
    sectionTint: "bg-red-50/30",
    icon: "Wrench",
    // Sharp design - minimal border radius
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  auto: {
    label: "Auto & Moto",
    accentColor: "#3b82f6",
    accentClass: "text-blue-500",
    accentBg: "bg-blue-600",
    accentBgHover: "hover:bg-blue-700",
    accentRing: "ring-blue-500",
    accentBorder: "border-blue-500",
    accentSoft: "bg-blue-50",
    accentSoftText: "text-blue-700",
    heroBg: "bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900",
    sectionTint: "bg-slate-50",
    icon: "Car",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  home: {
    label: "Casă & Living",
    accentColor: "#0d9488",
    accentClass: "text-teal-600",
    accentBg: "bg-teal-600",
    accentBgHover: "hover:bg-teal-700",
    accentRing: "ring-teal-500",
    accentBorder: "border-teal-500",
    accentSoft: "bg-teal-50",
    accentSoftText: "text-teal-700",
    heroBg: "bg-gradient-to-br from-stone-900 via-stone-800 to-teal-950",
    sectionTint: "bg-stone-50",
    icon: "Home",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  beauty: {
    label: "Beauty & Cosmetice",
    accentColor: "#db2777",
    accentClass: "text-pink-600",
    accentBg: "bg-pink-600",
    accentBgHover: "hover:bg-pink-700",
    accentRing: "ring-pink-500",
    accentBorder: "border-pink-500",
    accentSoft: "bg-pink-50",
    accentSoftText: "text-pink-700",
    heroBg: "bg-gradient-to-br from-pink-500 via-pink-600 to-rose-700",
    sectionTint: "bg-pink-50/40",
    icon: "Sparkles",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  tech: {
    label: "Tech & Gadgets",
    accentColor: "#0891b2",
    accentClass: "text-cyan-500",
    accentBg: "bg-cyan-600",
    accentBgHover: "hover:bg-cyan-700",
    accentRing: "ring-cyan-500",
    accentBorder: "border-cyan-500",
    accentSoft: "bg-cyan-50",
    accentSoftText: "text-cyan-700",
    heroBg: "bg-gradient-to-br from-cyan-500 via-cyan-600 to-blue-700",
    sectionTint: "bg-cyan-50/30",
    icon: "Smartphone",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  fitness: {
    label: "Sport & Fitness",
    accentColor: "#ea580c",
    accentClass: "text-orange-600",
    accentBg: "bg-orange-600",
    accentBgHover: "hover:bg-orange-700",
    accentRing: "ring-orange-500",
    accentBorder: "border-orange-500",
    accentSoft: "bg-orange-50",
    accentSoftText: "text-orange-700",
    heroBg: "bg-gradient-to-br from-orange-500 via-orange-600 to-red-600",
    sectionTint: "bg-orange-50/40",
    icon: "Dumbbell",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  kitchen: {
    label: "Bucătărie & Gătit",
    accentColor: "#d97706",
    accentClass: "text-amber-600",
    accentBg: "bg-amber-600",
    accentBgHover: "hover:bg-amber-700",
    accentRing: "ring-amber-500",
    accentBorder: "border-amber-500",
    accentSoft: "bg-amber-50",
    accentSoftText: "text-amber-700",
    heroBg: "bg-gradient-to-br from-amber-500 via-amber-600 to-orange-600",
    sectionTint: "bg-amber-50/40",
    icon: "ChefHat",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  kids: {
    label: "Copii & Jucării",
    accentColor: "#ca8a04",
    accentClass: "text-yellow-600",
    accentBg: "bg-yellow-500",
    accentBgHover: "hover:bg-yellow-600",
    accentRing: "ring-yellow-500",
    accentBorder: "border-yellow-500",
    accentSoft: "bg-yellow-50",
    accentSoftText: "text-yellow-700",
    heroBg: "bg-gradient-to-br from-yellow-400 via-orange-400 to-pink-500",
    sectionTint: "bg-yellow-50/40",
    icon: "Baby",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  pets: {
    label: "Animale de Companie",
    accentColor: "#b45309",
    accentClass: "text-amber-700",
    accentBg: "bg-amber-700",
    accentBgHover: "hover:bg-amber-800",
    accentRing: "ring-amber-600",
    accentBorder: "border-amber-600",
    accentSoft: "bg-amber-50",
    accentSoftText: "text-amber-800",
    heroBg: "bg-gradient-to-br from-amber-600 via-amber-700 to-stone-600",
    sectionTint: "bg-amber-50/30",
    icon: "PawPrint",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  garden: {
    label: "Grădină & Terasă",
    accentColor: "#059669",
    accentClass: "text-emerald-600",
    accentBg: "bg-emerald-600",
    accentBgHover: "hover:bg-emerald-700",
    accentRing: "ring-emerald-500",
    accentBorder: "border-emerald-500",
    accentSoft: "bg-emerald-50",
    accentSoftText: "text-emerald-700",
    heroBg: "bg-gradient-to-br from-emerald-500 via-emerald-600 to-green-700",
    sectionTint: "bg-emerald-50/40",
    icon: "Leaf",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  fashion: {
    label: "Modă & Accesorii",
    accentColor: "#7c3aed",
    accentClass: "text-violet-600",
    accentBg: "bg-violet-600",
    accentBgHover: "hover:bg-violet-700",
    accentRing: "ring-violet-500",
    accentBorder: "border-violet-500",
    accentSoft: "bg-violet-50",
    accentSoftText: "text-violet-700",
    heroBg: "bg-gradient-to-br from-violet-500 via-violet-600 to-purple-700",
    sectionTint: "bg-violet-50/30",
    icon: "Shirt",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  health: {
    label: "Sănătate & Wellness",
    accentColor: "#0284c7",
    accentClass: "text-sky-600",
    accentBg: "bg-sky-600",
    accentBgHover: "hover:bg-sky-700",
    accentRing: "ring-sky-500",
    accentBorder: "border-sky-500",
    accentSoft: "bg-sky-50",
    accentSoftText: "text-sky-700",
    heroBg: "bg-gradient-to-br from-sky-500 via-sky-600 to-blue-700",
    sectionTint: "bg-sky-50/40",
    icon: "Heart",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
  general: {
    label: "Recomandate",
    accentColor: "#74b832",
    accentClass: "text-brand-600",
    accentBg: "bg-brand-600",
    accentBgHover: "hover:bg-brand-700",
    accentRing: "ring-brand-500",
    accentBorder: "border-brand-500",
    accentSoft: "bg-brand-50",
    accentSoftText: "text-brand-700",
    heroBg: "bg-gradient-to-br from-brand-500 via-brand-600 to-brand-700",
    sectionTint: "bg-brand-50/30",
    icon: "Sparkles",
    radius: "rounded-sm",
    radiusLg: "rounded-sm",
  },
};

export const getTheme = (category) => CATEGORY_THEMES[category] || CATEGORY_THEMES.general;
